import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Heading,
  SimpleGrid,
  Text,
  VStack
} from "@chakra-ui/react";
import { ReactComponent as NotFoundImage } from "assets/not-found.svg";
import { BasicLayout } from "layouts";

const NotFound: React.FC = () => {
  return (
    <BasicLayout showLogo>
      <Container maxWidth="1080px" minH="100vh">
        <SimpleGrid
          height="100vh"
          columns={[1, 1, 1, 2]}
          justifyContent="space-evenly"
        >
          <Box alignSelf="center" justifySelf="center" w="100%" maxW={{ base: "200px", md: "100%" }}>
            <NotFoundImage width="100%" />
          </Box>
          <VStack
            width="fit-content"
            spacing={{ base: 4, md: 10 }}
            justifySelf={{ base: "flex-start", md: "center" }}
            justifyContent={{ base: "flex-start", md: "center" }}
            alignItems={{ base: "center", md: "flex-start" }}
          >
            <Text
              fontSize={{ base: "100px", md: "200px" }}
              fontWeight="bold"
              color="blue.500"
              lineHeight="none"
            >
              404
            </Text>
            <Box textAlign={{ base: "center", md: "left" }}>
              <Heading fontSize={{ base: "2xl", md: "4xl" }} fontWeight="semibold">
                Looks like you&apos;re lost
              </Heading>
              <Text mt="0.75rem">
                The page you&apos;re looking for is not available!
              </Text>
            </Box>
            <Link to="/">
              <Button
                variant="link"
                color="blue.500"
                _hover={{
                  color: 'white'
                }}
                as="a"
              >
                Go To Home &rarr;
              </Button>
            </Link>
          </VStack>
        </SimpleGrid>
      </Container>
    </BasicLayout >
  );
};

export default NotFound;
